import { TFunction } from 'i18next';
import { marketByCountryCode } from './market';

function getCountryName(t: TFunction, countryCode?: string | null) {
  const market = marketByCountryCode(countryCode);

  return market ? t(`common:enums.country_code.${market.country_code}`) : null;
}

export { getCountryName };
